import React, { useEffect, useState } from "react";
import { historyService } from "../services/history";
import toast from "react-hot-toast";

const HistoricoRecente = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true);
        const data = await historyService.getHistory(5); // Buscar os 5 últimos registros
        setHistory(Array.isArray(data) ? data : []);
        setError("");
      } catch (err) {
        setError(err.message || "Erro ao carregar histórico.");
        console.error("Erro ao carregar histórico:", err);
        // Definir history como vazio array em caso de erro
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  const renderDetalhes = (detalhes) => {
    if (!detalhes || typeof detalhes !== "object") {
      return <span className="text-gray-500 italic">Sem detalhes</span>;
    }

    // Para ações de CRIACAO, mostrar informações específicas
    if (detalhes.novo_produto) {
      return (
        <span>
          Novo produto: <strong>{detalhes.novo_produto.name}</strong> ({detalhes.novo_produto.product_code})
        </span>
      );
    }
    if (detalhes.nova_encomenda) {
      return (
        <span>
          Nova encomenda: <strong>{detalhes.nova_encomenda.order_number}</strong> para {detalhes.nova_encomenda.client_name}
        </span>
      );
    }
    if (detalhes.nova_expedicao) {
      return (
        <span>
          Nova expedição: <strong>{detalhes.nova_expedicao.expedition_number}</strong>
        </span>
      );
    }

    // Para ações de EDICAO, verificar se tem formato antigo (antes/depois) ou novo (de/para)
    if (detalhes.antes && detalhes.depois) {
      // Formato antigo - converter para o novo formato
      const alteracoes = [];
      const antes = detalhes.antes;
      const depois = detalhes.depois;
      
      for (const key in depois) {
        if (antes[key] !== depois[key]) {
          alteracoes.push([key, { de: antes[key], para: depois[key] }]);
        }
      }
      
      if (alteracoes.length > 0) {
        return (
          <div className="space-y-1">
            {alteracoes.map(([key, value]) => (
              <div key={key} className="text-xs">
                <strong>{key}:</strong> "{String(value.de)}" → "{String(value.para)}"
              </div>
            ))}
          </div>
        );
      }
    }

    // Para ações de EDICAO com formato novo, mostrar as alterações
    const alteracoes = Object.entries(detalhes).filter(([key, value]) => {
      return (
        typeof value === "object" &&
        value !== null &&
        Object.prototype.hasOwnProperty.call(value, "de") &&
        Object.prototype.hasOwnProperty.call(value, "para") &&
        value.de !== value.para
      );
    });

    if (alteracoes.length > 0) {
      return (
        <div className="space-y-1">
          {alteracoes.map(([key, value]) => (
            <div key={key} className="text-xs">
              <strong>{key}:</strong> "{String(value.de)}" → "{String(value.para)}"
            </div>
          ))}
        </div>
      );
    }

    return <span className="text-gray-500 italic">Sem alterações registradas</span>;
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Histórico Recente</h2>
        <p>A carregar histórico...</p>
      </div>
    );
  }


  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold mb-4">Histórico Recente</h2>
      {history.length === 0 ? (
        <p className="text-neutral-500">
          Nenhum registo de histórico encontrado.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-neutral-200">
            <thead className="bg-neutral-50">
              <tr>
                <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider">
                  Data
                </th>
                <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider">
                  Responsável
                </th>
                <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider">
                  Ação
                </th>
                <th className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider">
                  Detalhes
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-neutral-200">
              {history.map((record) => (
                <tr key={record.id}>
                  <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-neutral-900">
                    {new Date(record.data_alteracao).toLocaleString('pt-BR')}
                  </td>
                  <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-neutral-900">
                    {record.usuario_nome || "Desconhecido"}
                  </td>
                  <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-neutral-900">
                    {record.acao} {record.entidade}
                  </td>
                  <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 text-xs sm:text-sm text-neutral-900">
                    {renderDetalhes(record.detalhes)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default HistoricoRecente;
